import React, { useMemo } from 'react';
import { useDischargeContext } from '~/hooks/discharge/useDischargeContext';
import PatientBoardList from '~/components/patient-board/PatientBoardList';
import { OwnershipFilter } from '~/components/patient-board/types';
import { mapDischargePatient, makeDischargeConfig } from './dischargeToVM';

interface Props {
  ownershipFilter?: OwnershipFilter;
}

const DischargePatientList: React.FC<Props> = ({ ownershipFilter = 'ALL' }) => {
  const { patients: allPatients, currentUser, takeOwnership } = useDischargeContext();

  const config = useMemo(() => makeDischargeConfig(takeOwnership), [takeOwnership]);

  const patients = useMemo(() => {
    const scoped =
      ownershipFilter === 'MY' ? allPatients.filter(p => p.assignedTo === currentUser) :
      ownershipFilter === 'UNASSIGNED' ? allPatients.filter(p => p.assignedTo == null) :
      allPatients;
    return scoped.map(mapDischargePatient);
  }, [allPatients, ownershipFilter, currentUser]);

  return <PatientBoardList patients={patients} config={config} ownershipFilter={ownershipFilter} />;
};

export default DischargePatientList;
